cv.PostEmptyView = Marionette.LayoutView.extend({
  className: 'post-empty',
  template: cv.Templates['posts/list/post_empty'],

  events : {
  },

  templateHelpers: function(){
    return {
    };
  },

  initialize: function(options){
    console.log('PostEmptyView initialized');
  },

  onShow: function(){
  }
});